import $ from 'jquery';

// Miscellaneous scripts relating to the checkout process
// Some things are handled generically in the ecommerce.js file,
// but custom stuff for Nectar only is here

$(function() {

    initHandleCheckoutButton();

    initOneClick();

});


function initHandleCheckoutButton() {

    //console.log('initHandleCheckoutButton');

    $('.custom-order-details-wrapper input[type=submit]').unbind('click');
    $('.custom-order-details-wrapper input[type=submit]').on('click', function(e) {

        //console.log('submit click');

        // Check default fields have content

        let $nameInput = $('input[name=\'custom_json[name]\']');
        if ($nameInput.val() == '') {
            $nameInput.css('border', 'solid 2px red');
            e.preventDefault();
        }

    });

}


function initOneClick() {

    // Function to disable a button or link after it has been clicked to prevent double orders ...

    $('.one-click').unbind('click');
    $('.one-click').on('click', function(e) {

        if ($(this).hasClass('clicked')) {
            console.log('double clicked');
            e.preventDefault();
            return false;
        } else {
            console.log('first click');
            $(this).addClass('clicked');
        }

    });

}
